
var _ = require('underscore');

/**
 * "Komprimiert" eine Liste von Nächten. Für Beispiele siehe die Funktion test().
 *
 * Beispiele:
 * [1, 2, 3, 5] => ["1-3", "5"]
 *
 * @param nights {Array} Liste der Nächte (muss sortiert sein)
 */
let compressNights = function(nights) {
    let lastSeen = null;
    let parts = [];
    let currentStack = [];

    for(let i = 0, night; night = nights[i]; ++i) {
        if ( lastSeen === null ) {
            currentStack.push(night);
            lastSeen = night;
            continue;
        }

        if ( night != lastSeen + 1 ) {
            let min = currentStack[0];
            let max = currentStack.pop();
            if ( min === max ) {
                parts.push(min);
            } else {
                parts.push(min + "-" + max);
            }
            currentStack = [];
        }
        currentStack.push(night);
        lastSeen = night;
    }

    if ( currentStack.length > 0 ) {
        let min = currentStack[0];
        let max = currentStack.pop();
        if ( min === max ) {
            parts.push(min + "");
        } else {
            parts.push(min + "-" + max);
        }
    }

    return parts;
};


/**
 * Erzeugt aus einer Liste von gültigen Nächten einen "menschlichen" String.
 * Beispiele:
 *   [3] = "3"
 *   [3, 4, 5] = "3-5"
 *   [3, 5, 7] = "3, 5 und 7"
 *
 * @param nights {Array} Liste der Nächte (muss sortiert sein)
 */
let humanString = function(nights) {
    var parts = compressNights(nights);
    switch ( parts.length ) {
        case 0: return "";
        case 1: 
            let nights = parts[0].indexOf('-21') !== -1 ? __('at_least') + ' ' + parts[0].split('-')[0] : parts[0];
            let label = parts[0] === "1" ? __("night") : __("nights");
            return nights + " " + label;
        default:
            let last_item = parts.pop();
            return __("nights_list", {
                nights: parts.join(", "),
                last_item: last_item,
            });
    }
};

if (process.env.NODE_ENV === 'development') {

    let test = function() {
        /* http://stackoverflow.com/a/14853974 */
        Array.prototype.equals = function (array) {
            // if the other array is a falsy value, return
            if (!array)
                return false;

            // compare lengths - can save a lot of time 
            if (this.length != array.length)
                return false;

            for (var i = 0, l=this.length; i < l; i++) {
                // Check if we have nested arrays
                if (this[i] instanceof Array && array[i] instanceof Array) {
                    // recurse into the nested arrays
                    if (!this[i].equals(array[i]))
                        return false;       
                }           
                else if (this[i] != array[i]) { 
                    // Warning - two different object instances will never be equal: {x:20} != {x:20}
                    return false;   
                }           
            }       
            return true;
        }   

        let test_cases = [
            { nights: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21],
              expected: [ "1-21" ] },
            { nights: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21],
              expected: [ "3-21" ] },
            { nights: [5, 7, 9],
              expected: [ 5, 7, 9 ] },
            { nights: [5, 7, 9, 10, 11],
              expected: [ 5, 7, "9-11" ] },
            { nights: [5, 7, 9, 10, 11, 13],
              expected: [ 5, 7, "9-11", 13 ] },
            { nights: [5, 6, 7, 9, 10, 11, 14, 21],
              expected: [ "5-7", "9-11", 14, 21 ] },
            { nights: [],
              expected: [] },
        ];

        var failed = 0;
        _.each(test_cases, function(testcase) {
            var result = compressNights(testcase.nights);
            if ( !result.equals(testcase.expected) ) {
                console.log("nights", testcase.nights);
                console.log("result", result);
                console.log("expected", testcase.expected);
                failed++;
            }
        });

        if ( !failed ) {
            console.log("Success: Fall tests passed!");
        }
    };
}

module.exports = {
    compressNights: compressNights,
    humanString: humanString,
};


// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/reserva/miniengine/NightsCompressor.js